import { isDefined } from "@clipboard-health/util-ts";
import { useWorkerGeoLocation } from "@src/appV2/Worker/useWorkerGeoLocation";
import { parseISO } from "date-fns";

import { useGetOpenShiftsForDates } from "../../Shift/Open/useGetOpenShiftsForDates";
import { useGetShiftDiscoveryDefaultDateRange } from "../../utils/useGetShiftDiscoveryDefaultDateRange";
import { usePayPreferenceFilterSettings } from "../featureFlags";
import { useShiftDiscoveryUserFiltersContext } from "../Filters/useUserFiltersContext";

interface UseUrgentShiftsDataProps {
  enabled?: boolean;
  ignorePayPreference?: boolean;
}

export function useUrgentShiftsData(props: UseUrgentShiftsDataProps = {}) {
  const { enabled = true, ignorePayPreference = true } = props;

  const { dates: dateStrings, distance, pay } = useShiftDiscoveryUserFiltersContext();
  const dates = dateStrings.map((dateString) => parseISO(dateString));

  const workerGeoLocation = useWorkerGeoLocation();
  const defaultDateRange = useGetShiftDiscoveryDefaultDateRange();

  const { enabled: payPreferenceFilterEnabled } = usePayPreferenceFilterSettings();

  return useGetOpenShiftsForDates({
    dates,
    dateRange: defaultDateRange,
    filter: {
      isUrgent: true,
      area: {
        latitude: workerGeoLocation?.latitude ?? 0,
        longitude: workerGeoLocation?.longitude ?? 0,
        radiusInMiles: distance,
      },
    },
    enabled: enabled && isDefined(workerGeoLocation),
    includeOffers: payPreferenceFilterEnabled && !ignorePayPreference && pay > 0,
  });
}
